





























import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import { Sheet, Examinee } from "../../modules/teacher/ResultRankList"


export interface Data {
  sheet_group_key: string
  sheet: Sheet
  examinees: Examinee[]
  fields: any[]
  SheetTypeEnum: Readonly<{Normal: number; Cbt: number; Entrance: number}>
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sheet_group_key: "",
      sheet: new Sheet({}),
      examinees: new Array<Examinee>(),
      fields: [
        {key: "room_name", label: "クラス", sortable: true, class: 'text-center b-table-th-td'},
        {key: "student_no", label: "出席番号", sortable: true, class: 'text-center b-table-th-td'},
        {key: "student_no_character", label: "学籍番号", sortable: true, class: 'text-center b-table-th-td'},
        {key: "student_name", label: "氏名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "score", label: "得点", sortable: true, class: 'text-center b-table-th-td'},
        {key: "total_rank", label: "全体順位", sortable: true, class: 'text-center b-table-th-td'},
        {key: "room_rank", label: "クラス順位", sortable: true, class: 'text-center b-table-th-td'},
        {key: "detail", label: "個人成績", class: 'text-center'},
      ],
      SheetTypeEnum: Common.SheetTypeEnum,
      errors: [],
    });

    /************************************************************
     * ヘッダの実施日用文言生成
     ************************************************************/

    const convertExecDateText = (execDate: string) => {
      return execDate ? moment(execDate).format('Y年M月D日実施') : "";
    };

    /************************************************************
     * 個人成績画面へ遷移
     ************************************************************/

    const toPorsonResultDetail = (examinee: Examinee) => {
      context.root.$router.push(`/teacher_site/result_rank_detail/${examinee.sheet_id}/${examinee.student_no}`).catch(err => {});
    }

    const downloadExcel = async () => {
      await http.get(`/api/teacher/result_rank_list/download_excel/${state.sheet_group_key}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `成績一覧_${state.sheet.name}.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          alert(`エクセルのダウンロードに失敗しました。\n${errorData.errors[0]}`);
        }else{
          alert("エクセルのダウンロードに失敗しました。");
        }
      });
    };

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_group_key = context.root.$route.params.sheet_group_key;
      await http.get(`/api/teacher/result_rank_list?sheet_group_key=${state.sheet_group_key}`).then(response => {
        state.sheet = new Sheet(response.data.sheet);
        state.examinees = response.data.examinees.map((x: any) => new Examinee(x, response.data.examinees));
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        window.history.back();
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      convertExecDateText,
      toPorsonResultDetail,
      downloadExcel,
    }
  }
});

